import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ConfigService } from './config.service';
import { CapacitacionService } from './capacitacion.service';
import { MONTHS } from '../utils/constants';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const WORK_SHEET_NAMES = {
  REPORTE_INICIAL: 'Capacitaciones',
  ASISTENCIA: 'Asistentes'
}
@Injectable({
  providedIn: "root",
})
export class ExcelService {
  rows: any;
  rowsAssitance: any;
  private jsonContent = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem("batoken"),
      User: sessionStorage.getItem("userid"),
    }),
  };

  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private capacitacionService: CapacitacionService
  ) {}

  public async exportAsExcelRows(rows: any) {
    let rowsCapacitaciones = rows.map((capacitacion) =>
      this.buildRowExport(capacitacion)
    );
    let rowAsistentes = this.buildAsistentesExport(rows);

    const wsReportInic: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(rowsCapacitaciones);
    const wsReportAsist: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(rowAsistentes);
    const workbook: XLSX.WorkBook = {
      Sheets: {
        Capacitaciones: wsReportInic,
        Asistentes: wsReportAsist,
      },
      SheetNames: [
        WORK_SHEET_NAMES.REPORTE_INICIAL,
        WORK_SHEET_NAMES.ASISTENCIA,
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    this.saveAsExcelFile(excelBuffer, "Reporte");
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_tabla_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  buildRowExport(rows: any): any {
    return {
      "Id capacitación": rows.capacitacion.capacitacionId,
      "Nombre contratista":
        rows.capacitacion.nombreTrabajador +
        " " +
        rows.capacitacion.apellidoPaterno,
      "Tipo de capacitación": rows.capacitacion.capacitacionTypeDescription,
      "Nombre capacitación": rows.capacitacion.name,
      Categoría: rows.capacitacion.categoryDescription,
      Foco: rows.capacitacion.focoDescription,
      Enfoque: rows.capacitacion.enfoqueDescription,
      Zona: rows.capacitacion.zoneDescription,
      Ejecutor: rows.capacitacion.ejecutorDescription,
      Relator: rows.capacitacion.relatorDescription,
      Observación: rows.capacitacion.observation,
      "Mes de planificación": rows.capacitacion.month,
      "Año de planificación": rows.capacitacion.year,
      "Fecha planificación":
        rows.capacitacion.day +
        "/" +
        rows.capacitacion.month +
        "/" +
        rows.capacitacion.year,
      "Fecha de ejecución real": `${
        rows.capacitacion.realExecutionDate == null
          ? "-"
          : rows.capacitacion.realExecutionDate
      } `,
      "Duración real (HH)": `${
        rows.capacitacion.realHours == null ? "-" : rows.capacitacion.realHours
      } `,
      "Horas Estimadas": `${
        rows.capacitacion.estimatedHours == null
          ? "-"
          : rows.capacitacion.estimatedHours
      } `,
      "Horas Teoricas Real": `${
        rows.capacitacion.realTheoryHours == null
          ? "-"
          : rows.capacitacion.realTheoryHours
      } `,
      "Horas Prácticas Real": `${
        rows.capacitacion.realPracticeHours == null
          ? "-"
          : rows.capacitacion.realPracticeHours
      } `,
      "Asistentes Estimados": rows.capacitacion.estimatedAssistants,
      "Asistentes Reales": `${
        rows.capacitacion.realAssistants == null
          ? "-"
          : rows.capacitacion.realAssistants
      } `,
      "Fecha de creación": rows.capacitacion.creationDate,
      Estado: rows.capacitacion.stateShortDescription,
    };
  }
  buildAsistentesExport(rows: any): any {
    //const assitance = capacitacionWithAssistances;
    let arrayAssitentes = [];
    rows.forEach((row) => {
      if (
        row.assistanceRegistries != null &&
        row.assistanceRegistries != undefined &&
        row.assistanceRegistries.length > 0
      ) {
        row.assistanceRegistries.map((capacitacionItem) => {
          let asistente = this.buildRowAsistentes(capacitacionItem);
          arrayAssitentes.push(asistente);
        });
      }
    });

    return arrayAssitentes;
  }

  buildRowAsistentes(asistente: any): any {
    return {
      "ID Capacitacion": asistente.capacitacionId,
      "ID Asistencia": asistente.assistanceRegistryId,
      "Rut Trabajador": asistente.rutTrabajador,
      "Nombre Trabajador":
        asistente.nombreTrabajador +
        " " +
        asistente.apellidoPaterno +
        " " +
        asistente.apellidoMaterno,
    };
  }

  // public async exportAsExcelFile(offset: number, quantity: number, year: string, month: string, contratista: string, empresa: string, zona: string) {
  //   await this.capacitacionService.list(offset, quantity, year, month, contratista, empresa, zona)
  //     .then(capacitacionesWithAssistances => {
  //       this.rows = capacitacionesWithAssistances.map(capacitacionWithAssistances => this.buildRow(capacitacionWithAssistances));
  //       this.rowsAssitance = capacitacionesWithAssistances.map(capacitacionWithAssistances => capacitacionWithAssistances.assistanceRegistries);
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  //   const rowsnonull = this.rowsAssitance.filter(value => JSON.stringify(value) !== '[]');
  //   let cleanJSON = "[" + JSON.stringify(rowsnonull).replace(/[\[\]&]+/g, '') + "]";
  //   const assitanceReady = JSON.parse(cleanJSON);
  //   const rowsfinal = assitanceReady.map(assitanceReady => this.buildRowAssitances(assitanceReady));
  //   const wsReportInic: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.rows);
  //   const wsReportAsist: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowsfinal);
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: {
  //       'Tabla': wsReportInic,
  //       'Asistencia': wsReportAsist,
  //     }, SheetNames: [WORK_SHEET_NAMES.REPORTE_INICIAL, WORK_SHEET_NAMES.ASISTENCIA]
  //   };
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   this.saveAsExcelFile(excelBuffer, 'Reporte');
  // }
  // public async exportAsExcel(rows: any, rowsAssitance: any) {
  //   const rowsnonull = rowsAssitance.filter(value => JSON.stringify(value) !== '[]');
  //   let cleanJSON = "[" + JSON.stringify(rowsnonull).replace(/[\[\]&]+/g, '') + "]";
  //   const assitanceReady = JSON.parse(cleanJSON);
  //   const rowsfinal = assitanceReady.map(assitanceReady => this.buildRowAssitances(assitanceReady));
  //   const wsReportInic: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
  //   const wsReportAsist: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowsfinal);
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: {
  //       'Tabla': wsReportInic,
  //       'Asistencia': wsReportAsist,
  //     }, SheetNames: [WORK_SHEET_NAMES.REPORTE_INICIAL, WORK_SHEET_NAMES.ASISTENCIA]
  //   };
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   this.saveAsExcelFile(excelBuffer, 'Reporte');
  // }

  // buildRow(capacitacionWithAssistances: any): any {
  //   return {
  //     "ID": capacitacionWithAssistances.capacitacion.capacitacionId,
  //     "Rut Empresa": capacitacionWithAssistances.capacitacion.rutContratista,
  //     "Nombre Empresa": capacitacionWithAssistances.capacitacion.nombreContratista,
  //     "Nombre Contratista": capacitacionWithAssistances.capacitacion.nombreTrabajador + " " + capacitacionWithAssistances.capacitacion.apellidoPaterno,
  //     "Tipo de capacitación": capacitacionWithAssistances.capacitacion.capacitacionTypeDescription,
  //     "Nombre": capacitacionWithAssistances.capacitacion.name,
  //     "Categoría": capacitacionWithAssistances.capacitacion.categoryDescription,
  //     "Foco": capacitacionWithAssistances.capacitacion.focoDescription,
  //     "Enfoque": capacitacionWithAssistances.capacitacion.enfoqueDescription,
  //     "Zona": capacitacionWithAssistances.capacitacion.zoneDescription,
  //     "Ejecutor": capacitacionWithAssistances.capacitacion.ejecutorDescription,
  //     "Relator": capacitacionWithAssistances.capacitacion.relatorDescription,
  //     "Observación": capacitacionWithAssistances.capacitacion.observation,
  //     "Mes de planificación": this.getMonthLabel(capacitacionWithAssistances.capacitacion.month),
  //     "Fecha de ejecución real": capacitacionWithAssistances.capacitacion.realExecutionDate,
  //     "Cantidad de asistentes": capacitacionWithAssistances.capacitacion.realAssistants,
  //     "Duración real (HH)": `${capacitacionWithAssistances.capacitacion.realHours}hs`,
  //     "Horas Estimadas": `${capacitacionWithAssistances.capacitacion.estimatedHours == null ? "- " : capacitacionWithAssistances.capacitacion.estimatedHours}hs`,
  //     "Horas Teoricas Real": `${capacitacionWithAssistances.capacitacion.realTheoryHours == null ? "- " : capacitacionWithAssistances.capacitacion.realTheoryHours}hs`,
  //     "Horas Prácticas Real": `${capacitacionWithAssistances.capacitacion.realPracticeHours == null ? "- " : capacitacionWithAssistances.capacitacion.realPracticeHours}hs`,
  //     "Asistentes Estimados": capacitacionWithAssistances.capacitacion.estimatedAssistants,
  //     "Asistentes Reales": capacitacionWithAssistances.capacitacion.realAssistants,
  //     "Fecha de creación": capacitacionWithAssistances.capacitacion.creationDate,
  //     "Fecha de cierre": capacitacionWithAssistances.capacitacion.cierreDate,
  //     "Estado": capacitacionWithAssistances.capacitacion.stateShortDescription,

  //   };
  // }

  // buildRowAssitances(capacitacionWithAssistances: any): any {
  //   //const assitance = capacitacionWithAssistances;
  //   if (capacitacionWithAssistances != null && capacitacionWithAssistances != undefined)
  //     return {
  //       "ID Capacitacion": capacitacionWithAssistances.capacitacionId,
  //       "ID Asistencia": capacitacionWithAssistances.assistanceRegistryId,
  //       "Rut Trabajador": capacitacionWithAssistances.rutTrabajador,
  //       "Nombre Trabajador": capacitacionWithAssistances.nombreTrabajador + " " + capacitacionWithAssistances.apellidoPaterno + " " + capacitacionWithAssistances.apellidoMaterno
  //     };
  // }

  getMonthLabel(id: number): string {
    return MONTHS[id - 1].label;
  }

  downloadCapacitaciones(params: {
    year: string;
    month?: string | null;
    roleId?: number | null;
    userId?: number | null;
    empresaId?: number | null;
    page?: number;
    size?: number;
    sort?: string;
  }): Observable<void> {

    console.log(JSON.stringify(params))
    let hp = new HttpParams();
    Object.keys(params).forEach((k) => {
      const v = (params as any)[k];
      if (v !== null && v !== undefined && v !== "") {
        hp = hp.set(k, String(v));
      }
    });

    return this.http
      .get(
        this.configService.API_URL +
          "/capacitaciones/report/excel/capacitacion",
        {
          params: hp,
          observe: "response" as const,
          responseType: "blob" as const,
        }
      )
      .pipe(
        tap((res: HttpResponse<Blob>) => {
          const blob = res.body as Blob;
          const contentType = res.headers.get("Content-Type") || "";

          if (contentType.includes("application/json")) {
            readBlobAsText(blob).then((text) => {
              try {
                const err = JSON.parse(text);
                throw new Error(err.message || "Error al generar el archivo.");
              } catch {
                throw new Error(text || "Error al generar el archivo.");
              }
            });
            return;
          }

          const dispo = res.headers.get("Content-Disposition") || "";
          const filename =
            extractFilename(dispo) || `capacitaciones_${Date.now()}.xlsx`;

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        }),

        map(() => void 0),

        catchError((err) => {
          if (err.error instanceof Blob) {
            return new Promise<never>((_, reject) => {
              readBlobAsText(err.error).then((text) => {
                try {
                  const j = JSON.parse(text);
                  reject(
                    new Error(j.message || "Error al descargar el Excel.")
                  );
                } catch {
                  reject(new Error(text || "Error al descargar el Excel."));
                }
              });
            }) as any;
          }

          return throwError(() => err);
        })
      );
  }
}


function extractFilename(disposition: string): string | null {
 
  const matchQuoted = /filename\*?=(?:UTF-8''|)(["']?)([^;"']+)\1/i.exec(disposition);
  if (matchQuoted && matchQuoted[2]) {
    try { return decodeURIComponent(matchQuoted[2]); } catch { return matchQuoted[2]; }
  }
  return null;
}

function readBlobAsText(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve((fr.result as string) || '');
    fr.onerror = () => reject(fr.error || new Error('No se pudo leer el error.'));
    fr.readAsText(blob);
  });
}